import React from 'react';

const Contact: React.FC = () => {
  return (
    <div className="page-container">
      <div className="max-w-7xl mx-auto px-4 pb-12">
        <h1 className="text-4xl md:text-5xl font-bold mb-8 text-center">
          <span className="gradient-text">Contact Us</span>
        </h1>
        
        <div className="max-w-4xl mx-auto flex justify-center items-center min-h-[300px]">
          <div className="glass p-8 rounded-xl w-full max-w-md mx-auto">
            <h2 className="text-2xl font-semibold mb-6 text-center">Get in Touch</h2>
            <div className="space-y-4 text-center">
              <div>
                <h3 className="font-semibold mb-2">Guild Master</h3>
                <p className="text-text-secondary">Honeÿtea-Stormrage</p>
              </div>
              <div>
                <h3 className="font-semibold mb-2">Raid Leader</h3>
                <p className="text-text-secondary">Molarity-Stormrage</p>
              </div>
              <div>
                <h3 className="font-semibold mb-2">Horde Contact</h3>
                <p className="text-text-secondary">Annapolis-Stormrage</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact; 